import { useFetchEQLFields } from '@modules/common/hooks';
import { MetadataFieldMappingListItem } from '@modules/integrationsV2/components/LinkIntegrationMetadataSection/MetadataFieldMappingList/MetadataFieldMappingListItem';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { Box, Stack } from '@mui/material';

interface MetadataFieldMappingListProps {
  targetIntegrationSources: IntegrationSource[];
  sourceIntegrationSource: IntegrationSource;
}

export const MetadataFieldMappingList = ({
  targetIntegrationSources,
  sourceIntegrationSource,
}: MetadataFieldMappingListProps) => {
  const { fields: eqlFields } = useFetchEQLFields({
    fetchPolicy: 'cache-first', // Because we have "cache-and-network" on the root component, we can use "cache-first" here.
  });

  const {
    channel: { type: sourceChannelType },
    namespace: sourceNamespace,
    integrationType: sourceIntegrationType,
  } = sourceIntegrationSource;

  // Keep ingestion in-progress sources at the bottom, because mapping is disabled for them
  const sortedTargetIntegrationSources = [...targetIntegrationSources].sort(
    (a, b) => {
      if (a.isIngestionInProgress && !b.isIngestionInProgress) {
        return 1;
      }
      if (!a.isIngestionInProgress && b.isIngestionInProgress) {
        return -1;
      }
      return 0;
    },
  );

  return (
    <Stack spacing={4}>
      {sortedTargetIntegrationSources.map((targetIntegrationSource) => {
        const {
          channel: { type: targetChannelType },
          namespace: targetNamespace,
          integrationType: targetIntegrationType,
        } = targetIntegrationSource;

        const targetKey = `${targetChannelType}_${targetIntegrationType}_${targetNamespace}`;
        const sourceKey = `${sourceChannelType}_${sourceIntegrationType}_${sourceNamespace}`;

        return (
          <Box key={`${targetKey}_${sourceKey}`}>
            <MetadataFieldMappingListItem
              sourceIntegrationSource={sourceIntegrationSource}
              targetIntegrationSource={targetIntegrationSource}
              eqlFields={eqlFields}
            />
          </Box>
        );
      })}
    </Stack>
  );
};
